export enum InsuranceEnum {
  Ac = 'AC',
  AcMini = 'AC Mini',
  Assistance = 'Assistance',
  Nnw = 'NNW',
  Oc = 'OC',
}
